import { render, staticRenderFns } from "./ProceedWay.vue?vue&type=template&id=a71ba4e4&"
import script from "./ProceedWay.vue?vue&type=script&lang=js&"
export * from "./ProceedWay.vue?vue&type=script&lang=js&"
import style0 from "./ProceedWay.vue?vue&type=style&index=0&id=a71ba4e4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports